import './Hero.css';
import React from 'react';
import { motion } from 'framer-motion';
import Navbar from './Navbar';
import Breadcrumb from './Breadcrumb';
import { useLocation } from 'react-router-dom';

const Hero = ({
  title = (<><span className="highlight">Premium Touchless</span><br />Automatic<br />Car Wash System</>),
  subtitle = '',
  buttonText = 'Our Product',
  onButtonClick = () => {},
  children,
  bgImage,
  bgVideo // Add bgVideo prop
}) => {
  const defaultBg = 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1500&q=80';
  const location = useLocation();
  const isHome = location.pathname === '/';
  return (
    <section
      className={isHome ? 'hero-section1' : 'hero-section'}
      style={!bgVideo ? { backgroundImage: `url('${bgImage || defaultBg}')` } : {}}
    >
      {/* Render video background if bgVideo is provided */}
      {bgVideo && (
        <video
          className="hero-video-bg"
          src={bgVideo}
          autoPlay
          loop
          muted
          playsInline
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}
        />
      )}
      <Navbar />
      <div className="hero-overlay" style={bgVideo ? { position: 'absolute', inset: 0, backgroundColor: 'rgba(5,5,5,0.5)', zIndex: 1 } : {}}>
        <motion.div
          className="hero-content container"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
        >
          <h1>{title}</h1>
          <p className="hero-subtext">{subtitle}</p>
          <div className="hero-buttons">
            <button className="services-btn" onClick={onButtonClick}>{buttonText}</button>
          </div>
          {children}
        </motion.div>
        <Breadcrumb />
      </div>
    </section>
  );
};

export default Hero; 